var _defs, _circle, _line, _line2, _line3, _line4, _line5, _line6, _line7, _line8, _path, _circle2, _polygon, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgThunderstormDay(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    "data-name": "Layer 1",
    id: "Layer_1",
    viewBox: "0 0 64 64",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-1{fill:#efcc00;}.cls-2{fill:none;stroke:#efcc00;stroke-linecap:round;stroke-miterlimit:10;stroke-width:3px;}.cls-3{fill:url(#linear-gradient);}.cls-4{fill:url(#linear-gradient-2);}.cls-5{fill:#0baeff;}"), /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "matrix(-1, 0, 0, 1, -230.2, 0)",
    gradientUnits: "userSpaceOnUse",
    id: "linear-gradient",
    x1: -249.28,
    x2: -270.37,
    y1: 52.39,
    y2: 25.08
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#f2f2f2"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#cfcfcf"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    gradientTransform: "matrix(0, -1, -1, 0, 57.99, -275.31)",
    gradientUnits: "userSpaceOnUse",
    id: "linear-gradient-2",
    x1: -316.5,
    x2: -304.88,
    y1: 5.88,
    y2: 23.52
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.02,
    stopColor: "#fff"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#fff",
    stopOpacity: 0
  })))), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    className: "cls-1",
    cx: 39.8,
    cy: 22,
    r: 12.59
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 39.8,
    x2: 39.8,
    y1: 2,
    y2: 6.44
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 39.8,
    x2: 39.8,
    y1: 37.56,
    y2: 42
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 19.8,
    x2: 24.25,
    y1: 22,
    y2: 22
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 55.36,
    x2: 59.8,
    y1: 22,
    y2: 22
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 25.66,
    x2: 28.8,
    y1: 7.86,
    y2: 11
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 50.8,
    x2: 53.94,
    y1: 33,
    y2: 36.14
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 25.66,
    x2: 28.8,
    y1: 36.14,
    y2: 33
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    className: "cls-2",
    x1: 50.8,
    x2: 53.94,
    y1: 11,
    y2: 7.86
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    className: "cls-3",
    d: "M23.5,15.9A17.49,17.49,0,0,1,39,25.22a13.75,13.75,0,1,1,6.92,25.62L23.5,50.9a17.5,17.5,0,0,1,0-35Z"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    className: "cls-4",
    cx: 45.89,
    cy: 37.09,
    r: 13.75,
    transform: "translate(-2.18 71.3) rotate(-74.39)"
  })), _polygon || (_polygon = /*#__PURE__*/React.createElement("polygon", {
    className: "cls-1",
    points: "33.13 42.35 31 54.6 35.26 54.6 33.13 63.65 43.25 50.87 38.46 50.87 42.72 42.35 33.13 42.35"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    className: "cls-5",
    d: "M28.85,59.28a3.72,3.72,0,1,1-7.44,0c0-3.26,3-6.28,3.72-6.28S28.85,56,28.85,59.28Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgThunderstormDay);
export default __webpack_public_path__ + "static/media/thunderstorm_day.9268f92252e3bfc0038954447e517550.svg";
export { ForwardRef as ReactComponent };